import React from "react";

const Spacer = React.forwardRef(() => <div spacer='' style={{flexGrow: 1}}></div>)

export default Spacer
